module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('page-title', {
    attrs: {
      "title": "Criar nova tabela de medidas no Mercado Livre"
    }
  }), _vm._v(" "), _c('panel', {
    attrs: {
      "title": "Configurações iniciais"
    }
  }, [_c('form-group', {
    attrs: {
      "columns": 4,
      "label": "Conta",
      "required": true,
      "error": _vm.getError('account')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account),
      expression: "account"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.account = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.mercadoLivreAccounts), function(account) {
    return _c('option', {
      key: account.identifier,
      domProps: {
        "value": account.identifier
      }
    }, [_vm._v("\n          " + _vm._s(account.name) + " (" + _vm._s(account.nickname) + ")\n        ")])
  })], 2)]), _vm._v(" "), _c('general-category', {
    on: {
      "loading": _vm.isLoader,
      "selectedCategory": _vm.setSelectedCategory
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "columns": 4,
      "label": "Gênero",
      "required": true,
      "error": _vm.getError('gender')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gender),
      expression: "gender"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.gender = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.genders), function(gender) {
    return _c('option', {
      domProps: {
        "value": gender
      }
    }, [_vm._v(_vm._s(gender.name))])
  })], 2)])], 1), _vm._v(" "), (_vm.showSizeAttributes()) ? _c('panel', {
    attrs: {
      "title": "Valores da Guia de Medidas"
    }
  }, [_c('form-group', {
    attrs: {
      "label": "Nome da Guia de Medidas",
      "required": true,
      "error": _vm.getError('name'),
      "columns": 4
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Marca",
      "columns": 4,
      "required": true,
      "error": _vm.getError('brand')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brand),
      expression: "brand"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.brand = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.brands), function(brand) {
    return _c('option', {
      domProps: {
        "value": brand
      }
    }, [_vm._v(_vm._s(brand))])
  })], 2)])], 1) : _vm._e(), _vm._v(" "), (_vm.sizeAttributes) ? _c('panel', {
    attrs: {
      "title": "Tabela de Medidas"
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loadingSizeGrids
    }
  }), _vm._v(" "), (_vm.mainSizesOptions.length > 0) ? _c('form-group', {
    staticClass: "form-group l-col-12@md",
    attrs: {
      "label": "Tamanho Principal",
      "required": true,
      "error": _vm.getError('mainSize')
    }
  }, [_c('ul', {
    staticClass: "radio-inline"
  }, _vm._l((_vm.mainSizesOptions), function(value, k) {
    return _c('li', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.mainSize),
        expression: "mainSize"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": value.id,
        "checked": k === 0,
        "checked": _vm._q(_vm.mainSize, value.id)
      },
      on: {
        "change": function($event) {
          _vm.mainSize = value.id
        }
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(value.name))])])
  }), 0)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.sizeRows), function(sizeRow, i) {
    return _c('div', {
      staticClass: "l-row sizeRowItem"
    }, [(_vm.sizeRows.length > 1) ? _c('div', {
      staticClass: "hrTitle"
    }, [_c('span', {
      staticClass: "hr"
    }), _vm._v(_vm._s(i + 1)), _c('span', {
      staticClass: "hr right"
    })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.sizeAttributes), function(attribute) {
      return (attribute.mainAttribute === undefined || attribute.mainAttribute === false) ? _c('div', {
        staticClass: "l-col-2"
      }, [_c('form-group', {
        staticClass: "form-group l-col-12@md",
        attrs: {
          "label": attribute.label,
          "required": attribute.required,
          "error": _vm.getError(attribute.id, i)
        }
      }, [(attribute.type === 'text') ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.sizeRows[i][attribute.id]),
          expression: "sizeRows[i][attribute.id]"
        }],
        staticClass: "form-input",
        attrs: {
          "type": "text",
          "placeholder": _vm.getPlaceholder(attribute)
        },
        domProps: {
          "value": (_vm.sizeRows[i][attribute.id])
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.sizeRows[i], attribute.id, $event.target.value)
          }
        }
      }) : _vm._e(), _vm._v(" "), (attribute.type === 'number') ? _c('input', {
        directives: [{
          name: "mask",
          rawName: "v-mask",
          value: ('###.## cm'),
          expression: "'###.## cm'"
        }, {
          name: "model",
          rawName: "v-model",
          value: (_vm.sizeRows[i][attribute.id]),
          expression: "sizeRows[i][attribute.id]"
        }],
        staticClass: "form-input",
        attrs: {
          "type": "text",
          "placeholder": '999.99 ' + attribute.unity
        },
        domProps: {
          "value": (_vm.sizeRows[i][attribute.id])
        },
        on: {
          "change": function($event) {
            return _vm.validates(attribute, i)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.sizeRows[i], attribute.id, $event.target.value)
          }
        }
      }) : _vm._e(), _vm._v(" "), (attribute.type === 'multiselect') ? _c('multiselect', {
        attrs: {
          "options": attribute.values,
          "selectLabel": "",
          "selectedLabel": "",
          "multiple": true,
          "placeholder": "Escolha",
          "label": "name",
          "track-by": "id"
        },
        model: {
          value: (_vm.sizeRows[i][attribute.id]),
          callback: function($$v) {
            _vm.$set(_vm.sizeRows[i], attribute.id, $$v)
          },
          expression: "sizeRows[i][attribute.id]"
        }
      }) : _vm._e(), _vm._v(" "), (attribute.min && attribute.max) ? _c('span', [_c('small', [_vm._v("entre " + _vm._s(attribute.min) + " e " + _vm._s(attribute.max) + " " + _vm._s(attribute.unity) + " * ")])]) : _vm._e()], 1)], 1) : _vm._e()
    }), _vm._v(" "), _c('div', {
      staticClass: "l-col-2"
    }, [_c('button', {
      staticClass: "btn btn--info",
      staticStyle: {
        "background-color": "#ed3e3e",
        "border-color": "#ed3e3e",
        "margin-top": "22px"
      },
      attrs: {
        "disabled": _vm.sizeRows.length < 2
      },
      on: {
        "click": function($event) {
          return _vm.removeSize(i)
        }
      }
    }, [_vm._v("Remover")])])], 2)
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn--default",
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": _vm.addSizeRow
    }
  }, [_vm._v("Adicionar Tamanho")])], 2) : _vm._e(), _vm._v(" "), _c('panel', [_c('button', {
    staticClass: "btn btn--success",
    class: {
      'is-loading': _vm.saving
    },
    attrs: {
      "disabled": _vm.saving,
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Criar")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e96aa82","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/SizeGrid/MercadoLivre/Create.vue
// module id = 3209
// module chunks = 0